export const pages = {
    ABOUT: 'about',
    DATING: 'dating',
    TESTIMONIALS: 'testimonials',
    STORIES: 'stories'
}